var _circle, _circle2, _g, _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundRoadv3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 730,
    height: 656,
    viewBox: "0 0 730 656",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 365,
    cy: 328,
    r: 328,
    fill: "url(#paint0_linear_25_51)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25_51",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 0,
    width: 656,
    height: 656
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 365,
    cy: 328,
    r: 328,
    fill: "url(#paint1_linear_25_51)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25_51)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.9361,
    y: 386.349,
    width: 691.123,
    height: 13.5959,
    fill: "#353434"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -9.4525,
    y: 423.737,
    width: 695.655,
    height: 20.3938,
    fill: "#353434"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.1754,
    y: 516.451,
    width: 585.907,
    height: 39.36,
    fill: "#353434"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.6959,
    y: 471.127,
    width: 629.94,
    height: 27.4327,
    fill: "#353434"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.1226,
    y: 588.021,
    width: 585.755,
    height: 40.7875,
    fill: "#353434"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 161,
    width: 104,
    height: 193,
    fill: "#353434"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 331,
    y: 130,
    width: 104,
    height: 193,
    fill: "#353434"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 238,
    width: 117,
    height: 189,
    fill: "#353434"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 149,
    y: 176,
    width: 104,
    height: 193,
    fill: "#353434"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 190,
    width: 104,
    height: 187,
    fill: "#353434"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 572H627.5L730 656H0L102.5 572Z",
    fill: "#1A111E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M243.147 607H325.853V620H227L243.147 607Z",
    fill: "#E5E5E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1473 607H166.853L149.5 620H108.75H68L84.1473 607Z",
    fill: "#E5E5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M402.147 607H484.853L501 620H402.147L402.147 607Z",
    fill: "#E5E5E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M561.147 607H643.853L660 620H576L561.147 607Z",
    fill: "#E5E5E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_51",
    x1: 365,
    y1: 0,
    x2: 365,
    y2: 656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D27723"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25_51",
    x1: 365,
    y1: 0,
    x2: 365,
    y2: 656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D27723"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundRoadv3);
export default __webpack_public_path__ + "static/media/BackgroundRoadv3.55b1c074f7dd9136dc956b41f0ecdb17.svg";
export { ForwardRef as ReactComponent };